export const EMAIL = /^(?!.*--)(?!.*\.\.)(?!.*[+.-][+.-])[\w+.-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const PHONE_NUMBER = /^( *\([0-9]{3}\) [0-9]{3}\-[0-9]{4} *)$/;
export const SSN_NUMBER = /^(\d{3})[-](\d{2})[-](\d{4})$/;
export const NON_ZERO_CURRENCY = /^(?!0*(\.0+)?$)(\d+|\d*\.\d+)$/;
export const EIN_NUMBER = /^(\d{9})$/;

export const NUMBER_TEXT_SPECIAL = '[^0-9a-zA-Z_\-]';